import { Package } from 'lucide-react';

function ProductTile({ product, onClick }) {
  return (
    <div
      data-testid={`product-tile-${product.id}`}
      onClick={() => onClick(product)}
      className="group bg-white rounded-lg border border-slate-200 overflow-hidden cursor-pointer transition-all hover:border-[#01195d]/40 hover:shadow-md"
    >
      <div className="aspect-square bg-slate-50 overflow-hidden">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Package className="w-10 h-10 text-slate-300" />
          </div>
        )}
      </div>
      <div className="p-3">
        <h4 className="font-semibold text-sm text-slate-800 line-clamp-2 mb-0.5" data-testid={`product-tile-name-${product.id}`}>
          {product.name}
        </h4>
        {product.brand && <p className="text-xs text-slate-500 truncate">{product.brand}</p>}
        {product.unit_size && <p className="text-xs text-slate-400 mt-0.5">{product.unit_size}</p>}
      </div>
    </div>
  );
}

function EmptyState({ label }) {
  return (
    <div className="text-center py-16 bg-white rounded-xl border border-dashed border-slate-200">
      <Package className="w-12 h-12 mx-auto mb-3 text-slate-300" />
      <p className="text-slate-500 text-sm">{label}</p>
    </div>
  );
}

export function ProductGrid({ category, products, onProductClick }) {
  if (!category) return null;
  const list = products || [];
  return (
    <div data-testid="product-grid">
      <div className="mb-4 flex items-baseline justify-between">
        <h3 className="text-xl font-bold text-slate-900" data-testid="product-grid-title">
          {category.name}
        </h3>
        <span className="text-xs text-slate-500">
          {list.length} {list.length === 1 ? 'product' : 'products'}
        </span>
      </div>
      {category.description && (
        <p className="text-sm text-slate-600 mb-5">{category.description}</p>
      )}
      {!products ? (
        <div className="text-center py-16 text-slate-400 text-sm">Loading…</div>
      ) : list.length === 0 ? (
        <EmptyState label="Products for this category are being uploaded. Please check back soon." />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          {list.map(p => <ProductTile key={p.id} product={p} onClick={onProductClick} />)}
        </div>
      )}
    </div>
  );
}

export default ProductGrid;
